export default __webpack_public_path__ + "static/media/potosinos-logo.67e7d47f.png";